module.exports = __webpack_public_path__ + "static/img/5.0112b35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/5.png
// module id = QdpU
// module chunks = 0